// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"5f4733ec","218":"5f4733ec","227":"5f4733ec","315":"5f4733ec","778":"5f4733ec"}[chunkId] + ".chunk.css";
};